import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  Tooltip,
} from '@mui/material';
import { ReactNode, FC } from 'react';

export interface TooltipButtonProps extends MuiButtonProps {
  tooltip?: ReactNode;
}

const TooltipButton: FC<TooltipButtonProps> = ({
  tooltip,
  disabled,
  children,
  ...props
}) => {
  const button = (
    <MuiButton {...props} disabled={disabled}>
      {children}
    </MuiButton>
  );

  return tooltip ? (
    <Tooltip arrow title={tooltip}>
      <span style={{ display: 'block', width: 'fit-content' }}>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

export default TooltipButton;
